<template>
  <div class="main-container-layout">
    <el-container ref="contentContainer">
      <!-- <el-main class="main-full-width"> -->
        <transition name="fade" mode="out-in">
          <div :class="contentWrapperClass">
            <router-view />
          </div>
        </transition>
      <!-- </el-main> -->
    </el-container>
    <div id="footer" ref="footer">
      <DsFooter />
    </div>
  </div>
</template>

<script>
  import DsFooter from './DsFooter'

  export default {
    name: 'MainContainer',
    components: { DsFooter },
    data() {
      return {
        footerResizeObserver: null
      }
    },
    computed: {
      useDsHomeLayout() {
        return this.$route.name === 'Home'
      },
      contentWrapperClass() {
        return this.useDsHomeLayout ? 'route-content route-content--home' : 'route-content route-content--centered'
      }
    },
    watch: {
      '$route.path'() {
        this.updateFooterOffset()
      }
    },
    methods: {
      updateFooterOffset() {
        this.$nextTick(() => {
          const contentContainerRef = this.$refs.contentContainer
          const contentContainerEl = contentContainerRef && (contentContainerRef.$el || contentContainerRef)
          const footerWrapper = this.$refs.footer
          const footerContent = footerWrapper && footerWrapper.firstElementChild
          const footerHeightSource = footerContent || footerWrapper
          const footerHeight = footerHeightSource ? Math.ceil(footerHeightSource.getBoundingClientRect().height) : 0
          const footerBaseOffset = footerHeight - 5
          const footerOffset = `${footerBaseOffset}px`

          if (contentContainerEl && contentContainerEl.style) {
            contentContainerEl.style.setProperty('--footer-offset', footerOffset)
            contentContainerEl.style.paddingBottom = footerOffset
          }

          if (this.$el && this.$el.style) {
            this.$el.style.setProperty('--footer-offset', footerOffset)
          }
        })
      }
    },
    mounted() {
      this.updateFooterOffset()
      window.addEventListener('resize', this.updateFooterOffset)

      if (typeof ResizeObserver !== 'undefined' && this.$refs.footer) {
        this.footerResizeObserver = new ResizeObserver(() => this.updateFooterOffset())
        this.footerResizeObserver.observe(this.$refs.footer)
        if (this.$refs.footer.firstElementChild) {
          this.footerResizeObserver.observe(this.$refs.footer.firstElementChild)
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateFooterOffset)
      if (this.footerResizeObserver) {
        this.footerResizeObserver.disconnect()
      }
    }
  }
</script>

<style scoped>
  .main-container-layout {
    --footer-offset: 136px;
    min-height: 0;
    height: calc(100vh - 80px);
    height: calc(100dvh - 80px);
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .main-container-layout > .el-container {
    flex: 1 1 auto;
    min-height: 0;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    overflow: auto;
     padding-bottom: var(--footer-offset);
    -webkit-overflow-scrolling: touch;
  }

  .main-container-layout .el-main {
    overflow: visible;
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 0.1s ease;
  }

  .fade-leave-active {
    transition: opacity 0.1s ease;
    opacity: 0;
  }

  .main-full-width {
    margin-top: 0 !important;
    margin-left: 0 !important;
    padding: 0 !important;
  }

  .route-content {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .route-content--home {
    max-width: none;
    padding: 0;
  }

  .route-content--centered {
    max-width: 1320px;
    margin: 0 auto;
    padding: 24px 32px 36px;
  }

  #footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    padding-left: 32px;
    padding-right: 32px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    z-index: 900;
    pointer-events: none;
  }

  #footer > * {
    width: 100%;
    max-width: 1320px;
    margin: 0 auto;
    pointer-events: auto;
  }

  @media (max-width: 900px) {
    #footer {
      padding-left: 16px;
      padding-right: 16px;
    }

    .route-content--centered {
      padding: 16px;
    }
  }
</style>

